<template>
  <v-container class="pa-0">
    <div
      v-if="$route.params.isUser === '0'"
    >
      <AccountToolBar
        class="pa-3"
        :account-info="account"
      />
      <v-row
        class="orderStatus px-5 py-3"
        align="center"
        no-gutters
      >
        <v-dialog
          ref="datePicker"
          v-model="datePicker"
          :return-value.sync="dateRange"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              class="ma-0"
              label="訂單查詢"
              append-icon="mdi-calendar"
              readonly
              clearable
              hide-details=""
              outlined
              dense
              append-outer-icon="mdi-magnify"
              v-bind="attrs"
              v-on="on"
              @click:append="datePicker = true"
            />
          </template>
          <v-date-picker
            v-model="dateRange"
            range
            locale="zh"
            color="primary"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="datePicker = false"
            >
              取消
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.datePicker.save(dateRange)"
            >
              確認
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <!-- <v-btn
            class="btn btn-sm"
            icon
            color="primary"
            @click="getOrderByCondition()"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn> -->
      </v-row>
    </div>
    <h2
      v-else
      class="pa-3 text-center"
    >
      我的訂單
    </h2>

    <v-tabs
      v-model="tabs"
      color="primary"
      centered
      fixed-tabs
    >
      <v-tab
        v-for="item in tabList"
        :key="item.value"
      >
        <div
          color="primary"
          class="font-weight-bold"
          style="font-size: 18px"
        >
          {{ item.text }}
        </div>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item
        v-for="item in tabList"
        :key="item.value"
      >
        <v-container
          class="pa-0"
        >
          <v-row
            justify="center"
            no-gutters
          >
            <v-col
              v-for="item in orderInfo"
              :key="item.id"
              cols="12"
              sm="10"
              class="mt-2"
            >
              <OrderInfoBox
                :order-info="item"
                :tabs="tabs"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import OrderInfoBox from '/src/components/OrderInfoBox.vue'
import AccountToolBar from '/src/components/AccountToolBar.vue'

export default {
  components: { OrderInfoBox, AccountToolBar },
  data () {
    return {
      account: {
        img: 'https://picsum.photos/500/300?image=16',
        accountId: '1',
        accountName: '不想回家',
        address: '台東縣',
        mobile: '0965-507-555'

      },
      tabList: [
        {
          text: '待付款',
          value: 0
        },
        {
          text: '已成立',
          value: 1
        },
        {
          text: '已失效',
          value: 2
        },
        {
          text: '已結束',
          value: 3
        }
      ],
      tabs: 0,
      orderInfo: [
        {
          id: 1,
          orderDate: '2022-03-09',
          name: '不想回家',
          orderId: '000001',
          price: 3800,
          orderStatus: '愈時未付款 2022-03-10 22:00',
          // updatedAt: '2022-03-09',
          img: 'https://picsum.photos/500/300?image=16'
        },
        {
          id: 2,
          orderDate: '2022-03-09',
          name: '花間露',
          orderId: '000002',
          price: 3800,
          orderStatus: '未付款',
          // updatedAt: '2022-03-09',
          img: 'https://picsum.photos/500/300?image=19'
        },
        {
          id: 3,
          orderDate: '2022-03-09',
          name: '花間露',
          orderId: '000003',
          price: 3800,
          orderStatus: '已付款 2022-03-09 22:00',
          // updatedAt: '2022-03-09',
          img: 'https://picsum.photos/500/300?image=40'
        }
      ],
      // daePicker
      dateRange: [],
      datePicker: false
    }
  },
  computed: {
    dateRangeText: {
      get () {
        // return this.selected
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        let dateRange = this.dateRange.sort((x, y) =>
          this.$root.moment().diff(y, 'minutes') - this.$root.moment().diff(x, 'minutes'))

        return dateRange.join(' ~ ')
      }
    }
  }
}
</script>

<style scoped>
.orderStatus{
    background-color:#F0F0F0;
}
</style>
